module.exports = __webpack_public_path__ + "img/lit_carn.35b93fcd.png";